import t, { useIntl } from '@jetshop/intl';
import Accordion from '@jetshop/ui/Accordion/Accordion';
import React, { useState } from 'react';
import { styled } from 'linaria/react';
import { TabInner } from './ProductTabs';
import { SVG } from '../../../../assets/SVG';
import { useCustomFields } from '../useCustomFields';
import { Above } from '@jetshop/ui/Breakpoints';

const ProductSection = styled('div')`
  color: #333;
  font-size: 14px;
  line-height: 120%;
  width: 100%;
  border-top: 1px solid #f0f0f0;
  &:last-child {
    border-bottom: 1px solid #f0f0f0;
  }

  h3 {
    font-size: 14px;
    font-weight: 500;
    padding: 14px 0;
    display: flex;
    justify-content: space-between;
  }
`;

const AccordionWrapper = styled('span')`
  padding: 0 20px;
  display: block;
  margin: 20px 0;
`;
const IndicatorIcon = styled('span')`
  margin-left: auto;
  font-size: 1.25rem;
  svg {
    transition: all, 0.2s ease;
    &.down {
      transform: rotate(-90deg);
    }
    &.up {
      transform: rotate(0);
    }
  }
`;
const AccordionIndicator = ({ isOpen }) => (
  <IndicatorIcon>
    {isOpen ? (
      <SVG name="AngleDown" className="down up" />
    ) : (
      <SVG name="AngleDown" className="down" />
    )}
  </IndicatorIcon>
);

const showEAN = process.env.REACT_APP_SHOP_ID === 'life-fi';

const ProductInfoAccordion = ({
  product,
  setRemoteOpenIndex,
  remoteOpenIndex
}) => {
  const [expanded, setExpanded] = useState(false);
  const {
    specification,
    productSpecification,
    usageRDI,
    productUsageRDI,
    usageRestrictions,
    productUsage,
    organicCertificate,
    nutritional
  } = useCustomFields(product);

  const hasDescription = !!product?.description;
  const hasUsage =
    !!usageRDI || !!productUsageRDI || !!productUsage || !!usageRestrictions;
  // const hasSpecification = !!specification || !!productSpecification;
  const hasSpecification = !product?.customFields.length < 1;
  const customFields = product?.customFields;
  const EAN = product?.barcode;

  const translate = useIntl();
  const readMore = translate('Read more');

  return (
    <Accordion single initialOpenIndexes={[remoteOpenIndex ?? 0]}>
      {({ openIndexes, handleClick, AccordionContent }) => (
        <AccordionWrapper>
          {hasDescription && (
            <ProductSection>
              <h3 onClick={() => handleClick(0)}>
                <span>{t('Product description')}</span>
                <AccordionIndicator isOpen={openIndexes.includes(0)} />
              </h3>
              <AccordionContent isOpen={openIndexes.includes(0)}>
                <TabInner onClick={() => setExpanded(true)}>
                  {product?.description && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html:
                          expanded || product?.description?.length < 200
                            ? product?.description
                            : product?.description?.substring(0, 200) +
                              '... <u>' +
                              readMore +
                              '</u>'
                      }}
                    />
                  )}
                  {organicCertificate && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: organicCertificate.value
                      }}
                    />
                  )}
                  {!product?.description && !organicCertificate && (
                    <p>{t('No content')}</p>
                  )}

                  {showEAN ? (
                    EAN && <p>EAN: {EAN}</p>
                  ) : (
                    <p>
                      {t('Article number')}: {product?.articleNumber}
                    </p>
                  )}
                </TabInner>
              </AccordionContent>
            </ProductSection>
          )}

          {hasUsage && (
            <ProductSection>
              <h3 onClick={() => handleClick(1)}>
                <span>{t('Usage')}</span>
                <AccordionIndicator isOpen={openIndexes.includes(1)} />
              </h3>
              <AccordionContent isOpen={openIndexes.includes(1)}>
                <TabInner>
                  {usageRDI && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: usageRDI?.value
                      }}
                    />
                  )}
                  {productUsageRDI && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: productUsageRDI?.value
                      }}
                    />
                  )}
                  {usageRestrictions && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: usageRestrictions?.value
                      }}
                    />
                  )}
                  {productUsage && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: productUsage?.value
                      }}
                    />
                  )}
                </TabInner>
              </AccordionContent>
            </ProductSection>
          )}

          {hasSpecification && (
            <ProductSection>
              <h3 onClick={() => handleClick(2)}>
                <span>{t('Specifications')}</span>
                <AccordionIndicator isOpen={openIndexes.includes(2)} />
              </h3>
              <AccordionContent isOpen={openIndexes.includes(2)}>
                <Above breakpoint="sm2">
                  {matches =>
                    matches ? (
                      <TabInner>
                        {customFields.length < 1 ? (
                          <div>
                            <p className="even">Specifikationer saknas</p>
                          </div>
                        ) : (
                          customFields?.map((field, index) => {
                            return (
                              <div className={index % 2 === 0 ? 'even' : 'odd'}>
                                <p className="spec-title">{field?.title}</p>
                                <p className="spec-value">
                                  {field?.stringValue}
                                </p>
                              </div>
                            );
                          })
                        )}
                      </TabInner>
                    ) : (
                      <TabInner>
                        {customFields.length < 1 ? (
                          <div>
                            <p className="even">Specifikationer saknas</p>
                          </div>
                        ) : (
                          customFields?.map((field, index) => {
                            return (
                              <>
                                <div className="even">
                                  <p className="spec-title">{field?.title}</p>
                                </div>
                                <div className="odd">
                                  <p className="spec-value">
                                    {field?.stringValue}
                                  </p>
                                </div>
                              </>
                            );
                          })
                        )}
                      </TabInner>
                    )
                  }
                </Above>
              </AccordionContent>
            </ProductSection>
          )}
          {/* <ProductSection>
            <h3 onClick={() => handleClick(4)}>
              <span>{t('Reviews')}</span>
              <AccordionIndicator isOpen={openIndexes.includes(4)} />
            </h3>
            <AccordionContent isOpen={openIndexes.includes(4)}>
              <TabInner>
                <LipscoreReviewList
                  product={product}
                  lipscoreRef={lipscoreRef}
                />
              </TabInner>
            </AccordionContent>
          </ProductSection> */}
        </AccordionWrapper>
      )}
    </Accordion>
  );
};

export default ProductInfoAccordion;
